export default {
  en: {    
    bin: {
      next: 'Next',
      previous: 'Previous',
      mail: 'Email',
      push: 'Notification',
      change: 'Change',
      save: 'Save',
      at: 'at',
      company: 'Company',
      address: 'Address',
      amount: 'Amount',
      till: 'until',
      width: 'Breedte',
      length: 'Lengte',
      height: 'Hoogte',
      weight: 'Gewicht',
      cargo_weight: 'Max cargo weight',
      tos: 'Terms and conditions',
      insurance: 'Terms of insurance',
      toslink: 'https://www.vengo.technology/en/terms-and-conditions',
      insurancelink: 'https://www.vengo.technology/en/terms-and-conditions',
      resetpassword: 'Send e-mail with password reset link',
      dropzone: {
        selectfile: 'Click and select or drag file here.',
        filetoobig: 'This file is too big.',
        invalidfiletype: 'This file type is not supported.',
        delete: 'Remove',
      }
    }
  },
  nl: {    
    bin: {
      next: 'Volgende', 
      previous: 'Vorige',
      mail: 'E-mail',
      push: 'Melding',
      change: 'Wijzig',
      save: 'Opslaan',
      at: 'om',
      company: 'Bedrijf',
      cargo_weight: 'Laadvermogen',
      address: 'Adres',
      amount: 'Bedrag',
      till: 'tot',
      width: 'Breedte',
      length: 'Lengte',
      height: 'Hoogte',
      weight: 'Gewicht',
      tos: 'Algemene voorwaarden',
      insurance: 'Verzekeringsvoorwaarden',
      toslink: 'https://www.vengo.technology/nl/algemene-voorwaarden',
      insurancelink: 'https://www.vengo.technology/nl/algemene-voorwaarden',
      resetpassword: 'Verstuur e-mail om wachtwoord aan te passen',
      dropzone: {
        selectfile: 'Bestand selecteren of hiernaartoe slepen.',
        filetoobig: 'Het bestand is te groot!',
        invalidfiletype: 'Het bestandstype is niet toegestaan',
        delete: 'Verwijder',
      }
    }
  },
  fr: {    
    bin: {
      next: 'Prochain', 
      previous: 'Précédent',
      mail: 'E-mail',
      push: 'Notification',
      change: 'Change',
      save: 'Sauvegarder',
      at: 'à',
      company: 'Entreprise',
      cargo_weight: 'Charge utile',
      address: 'Adresse',
      amount: 'Montant',
      till: 'à',
      width: 'Largeur',
      length: 'Longeur',
      height: 'Hauteur',
      weight: 'Poids',
      tos: 'Termes et conditions',
      insurance: 'Conditions d’assurance',
      toslink: 'https://www.vengo.technology/fr/conditions-generales',
      insurancelink: 'https://www.vengo.technology/fr/conditions-generales',
      resetpassword: 'Envoyer un e-mail pour modifier le mot de passe',
      dropzone: {
        selectfile: 'Sélectionner fichier.',
        filetoobig: 'Le fichier est trop gros!',
        invalidfiletype: 'Le type de fichier n’est pas autorisé',
        delete: 'Supprimer'
      }
    }
  }
}
